import { deepNullToUndefined } from '@bodilenergy/util';

import { useBbrLookupByAddressQuery, useBbrLookupByDawaIdQuery } from '~src/gql';
import { useGraphQLClient } from '~src/services/client';
import { AddressInput } from '~src/types';
import { convertRoofFromCentimetersToMeters } from '~src/utilities/roof';

import { useToastMessageErrorHandler } from '../useToastMessage';
import { toValidAddressInput } from './serviceHelper';

const ONE_HOUR = 60 * 60 * 1000;

/** BBR by DAR address ID when the address came from the provider, otherwise by matching the address text. */
export const useBbrUnit = (addressInput?: Partial<AddressInput>, dawaId?: string) => {
  const { graphQLClient } = useGraphQLClient();
  const onError = useToastMessageErrorHandler();

  const address = dawaId ? undefined : toValidAddressInput(addressInput);

  const byAddress = useBbrLookupByAddressQuery(
    graphQLClient,
    { address: address! },
    {
      enabled: !!address,
      onError,
      staleTime: ONE_HOUR,
    }
  );

  const byDawaId = useBbrLookupByDawaIdQuery(
    graphQLClient,
    { dawaId: dawaId! },
    {
      enabled: !!dawaId,
      onError,
      staleTime: ONE_HOUR,
    }
  );

  const lookup = dawaId ? byDawaId.data?.bbrLookupByDawaId : byAddress.data?.bbrLookupByAddress;
  const isFetching = dawaId ? byDawaId.isFetching : byAddress.isFetching;

  const bbrUnit = deepNullToUndefined(lookup);

  return {
    bbrUnit: bbrUnit
      ? {
          ...bbrUnit,
          roofs: bbrUnit?.roofs?.map(convertRoofFromCentimetersToMeters),
        }
      : undefined,
    noBbrData: !isFetching && lookup === null,
    isFetching,
  };
};
